import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Sparkles } from "lucide-react";
import { api, getProductImage, formatPrice } from "@/lib/api";

export default function NewReleases() {
  const [releases, setReleases] = useState([]);

  useEffect(() => {
    api.get("/new-releases").then((r) => setReleases(r.data));
  }, []);

  return (
    <div data-testid="new-releases-page">
      <section className="hero-grid">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <span className="chip bg-brand-teal/15 text-brand-teal">
            <Sparkles size={12} /> Freshly stocked
          </span>
          <h1 className="mt-3 font-display text-4xl font-bold text-brand-navy sm:text-5xl lg:text-6xl">
            New releases & pre-orders
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-600">
            The latest sets, sealed product, and expansions to hit our shelves — sorted newest first.
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {releases.map((p, i) => (
            <article
              key={p.id}
              className="card-elevated grid overflow-hidden rounded-2xl md:grid-cols-[280px,1fr]"
              data-testid={`release-card-${p.id}`}
            >
              <Link to={`/product/${p.id}`} className="relative aspect-[4/3] overflow-hidden bg-slate-100 md:aspect-auto">
                <img
                  src={getProductImage(p)}
                  alt={p.name}
                  className="h-full w-full object-cover"
                />
                <span className="absolute left-4 top-4 chip bg-white text-brand-navy shadow-md">
                  #{i + 1} New
                </span>
              </Link>
              <div className="flex flex-col p-6">
                <div className="flex items-center gap-3">
                  <span className="chip bg-brand-teal/15 text-brand-teal">{p.category}</span>
                  {p.release_date && (
                    <span className="flex items-center gap-1 text-xs font-semibold text-slate-500">
                      <CalendarDays size={12} /> Released{" "}
                      {new Date(p.release_date).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </span>
                  )}
                </div>
                <h2 className="mt-3 font-display text-2xl font-bold text-brand-navy">
                  <Link to={`/product/${p.id}`} className="hover:text-brand-teal">
                    {p.name}
                  </Link>
                </h2>
                <p className="mt-2 text-sm text-slate-600">
                  {p.description || "Fresh release now in stock — shop it before it's gone."}
                </p>
                <div className="mt-auto flex flex-wrap items-center justify-between gap-4 pt-6">
                  <div>
                    <span className="font-display text-2xl font-extrabold text-brand-navy">
                      {formatPrice(p.price)}
                    </span>
                    {p.in_stock ? (
                      <span className="ml-3 chip bg-emerald-50 text-emerald-700">In stock</span>
                    ) : (
                      <span className="ml-3 chip bg-red-50 text-red-700">Sold out</span>
                    )}
                  </div>
                  <Link
                    to={`/product/${p.id}`}
                    className="btn-primary inline-flex rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-wider"
                    data-testid={`release-view-${p.id}`}
                  >
                    View product
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
